import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0d0f12",
      paper: "#15181d",
    },
    primary: {
      main: "#f4f4f5",
      contrastText: "#111216",
    },
    secondary: {
      main: "#8b949e",
    },
    text: {
      primary: "#f4f4f5",
      secondary: "#aeb4bc",
    },
  },
  shape: {
    borderRadius: 18,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: {
      fontWeight: 900,
      letterSpacing: "-0.06em",
    },
    h2: {
      fontWeight: 850,
      letterSpacing: "-0.04em",
    },
    h3: {
      fontWeight: 800,
      letterSpacing: "-0.03em",
    },
    button: {
      fontWeight: 800,
      textTransform: "none",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 18,
          minHeight: 44,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
      },
    },
  },
});
